import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const LoginPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "LoginPageContainer" */
      './LoginPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
